"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2021, a Tencent company. All rights reserved
 */
exports["default"] = {
  componentName: 'odc-metas-secondary',
  componentVersion: '0.0.1',
  name: 'odc-metas-secondary',
  version: '0.0.1'
};